import { Sidebar } from "@rio-cloud/rio-uikit";
import { type ComponentProps } from "react";
import { ExtractSummary } from "./ExtractSummary";
import { ExtractData } from "./types/types";
import { SummaryData } from "./types/summary";
import { ComplianceReviewsCard } from "./ComplianceReviewsCard";
import { OperationalCoherenceCard } from "./OperationalCoherenceCard";
import { OperationalDisciplineCard } from "./OperationalDisciplineCard";
import style from './ExtractSidebar.module.css'
import { WarrantyHistoryCard } from "./WarrantyHistoryCard";

export type ExtractSidebarProps = ComponentProps<typeof Sidebar> & {
  data: ExtractData;
  assetName: string;
  extractDate: string;
};

export function ExtractSidebar({ data, assetName, extractDate, ...props }: ExtractSidebarProps) {

  const summaryDate: SummaryData = {
    assetName: assetName,
    date: extractDate
  }

  const complianceReviews = data?.details?.find((item)=>item.description === 'CONFORMIDADE_REVISOES')
  const operationalCoherence = data?.details?.find((item)=>item.description === 'COERENCIA_OPERACIONAL')
  //const warrantyHistory = data?.details?.find((item)=>item.description === 'SEGURO_RESPONSAVEL')

  return (
    <Sidebar
      title={
        <div className="padding-x-10 text-color-dark">
          Extrato para {assetName}
        </div>
      }
      fly
      makeBackdropVisible
      hasBackdrop
      resizable
      minWidth={360}
      maxWidth={1080}
      width={720}
      position={Sidebar.RIGHT}
      {...props}
    >
      <div>
        <div className="cq-container">
          <div className="padding-x-20">
            <ExtractSummary summary={summaryDate} />
          </div>
          <div className='padding-20 display-grid grid-cols-1 cq-700:grid-cols-2 gap-20'>
            <div className="cq-700:col-span-full">
              <OperationalDisciplineCard score={data.score} level={data.level} maxScore={data.maxScore} nextLevelScore={data.nextLevelScore} lastScore={data.lastScore} />
            </div>
            <div>
              <ComplianceReviewsCard score={complianceReviews?.score} maxScore={complianceReviews?.maxScore} status={complianceReviews?.status} />
            </div>
            <div>
              <OperationalCoherenceCard score={operationalCoherence?.score} maxScore={operationalCoherence?.maxScore} status={operationalCoherence?.status} />
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}
